import defer from 'lodash/fp/defer';
export class User {
    constructor(authresponse) {

        authresponse = authresponse || {};

        this.affId = authresponse.affId || authresponse.affid || null;
        for ( let key in authresponse) {
            this[key] = authresponse[key];
        }

        this.id  = authresponse.id;
        this.login = authresponse.login;
        this.email = authresponse.email;
        this.group_id = authresponse.group_id;
        this._hasVodVox = false;
        this.loggedIn = !!this.id;

    }
    getAffId() {
        return this.affId;
    }

    isLogged() {
        return this.loggedIn;
    };

    hasVodVox() {
        let activeSubs = 0, i, sub;
        if (typeof this._hasVodVox !== 'undefined') { return this._hasVodVox; }
        if (typeof this.subscriptions === 'undefined') { return this._hasVodVox = false; }

        for (i = 0; i < this.subscriptions.length; i++) {
            sub = this.subscriptions[i];
            activeSubs += (1 === sub.state * 1) * (sub.has_vod || sub.has_vox);
        }
        this._hasVodVox = !!activeSubs;

        return this._hasVodVox;
    };

    hasActiveSubscriptions() {
        for ( let i in this.subscriptions ) {
            if ( this.subscriptions[i].state * 1 === 1 ) return true;
        }
        return false;
    };
}

export const initializeUser = ({affid, user}, navBarHTML) => {
    const w = window;

    user = user || {};
    w.user = new User({affId: affid, ...user});
    const FilmOn = w.FilmOn = w.FilmOn || {};
    FilmOn.User = w.user;

    const s = document.createElement('script');
    s.src = "https://www.filmon.com/tv/modules/FilmOnTV/js/build/common.js";
    s.type= "text/javascript";
    document.body.appendChild(s);

    const nav = document.getElementById('nav');

    if ( nav ) nav.innerHTML = navBarHTML;

    defer( function() {
        console.log("Initialize signup form....");
        const $ = window.$ || window.jQuery;
        const signUpForm = $('.sign-up-form');
        const $password = signUpForm.find('input[name="password"]'),
            $confirm = signUpForm.find('input[name="confirm-password"]'),
            $termsAgree = signUpForm.find("#id-checkboxxx");

        //we need this crutch because 'blur' event runs before 'click' and, if dom has changed by showError, click event doesn't fire
        let clickedElement = false;

        function showError( message ) {
            const error_span = $('<span/>').addClass('required-message');
            let self = this;
            if(!(self instanceof window.jQuery)) {
                self = $(self);
            }
            //to clear older messages, if they somehow haven't been cleared
            self.siblings('.required-message').remove();
            self.parent().append(error_span.text(message));
            self.addClass('required');
            const removal = function () {
                error_span.remove();
                self.removeClass('required').unbind('focus change', removal);
            };
            //bind 'change' for checkboxes
            self.bind('focus change', removal);
            if(clickedElement) {
                clickedElement.click();
                clickedElement = false;
            }
        }

        function validateInput() {
            const isPassword = $(this).is($password);
            if(isPassword)
                $confirm.removeAttr("pattern");
            // if the node has a required attribute but has no value
            if (this.validity.valueMissing) {
                showError.call(this, "Please fill out " + this.placeholder);
                return false;
            }
            if (!this.checkValidity()){
                if(isPassword && $(this).val().length > 70){
                    showError.call(this, "Password must not be longer than 70 characters");
                    return false;
                }
                showError.call(this, this.title);
                return false;
            }
            if(isPassword){
                $confirm[0].pattern =  this.value;
            }
            clickedElement = false;
            return true;
        }

        signUpForm.find('.text-field').each(function () {
            $(this).blur(validateInput.bind(this));
        });

        function checkFormValidity(form) {
            let isValid = true;
            const isSignUpForm = form.is('.sign-up-form');

            const email = form.find('input[name="email"]');
            email.val(email.val().trim());

            if(isSignUpForm){            //make right trim of passwords
                const pasVal = $password.val($password.val().replace(/\s+$/, '')).val(),
                    confirmVal = $confirm.val($confirm.val().replace(/\s+$/, '')).val();

                if ( email.val().length > 100 ){
                    showError.call(email,"Email must be less than 100 characters");
                    isValid = false;
                }
            }

            form.find('.text-field').each(function () {
                if(!validateInput.call(this)){
                    isValid = false;
                }
            });

            if(isSignUpForm && !$termsAgree.prop('checked')) {
                isValid = false;
                showError.call($termsAgree, $termsAgree[0].title);
            }
            return isValid;
        }

        $('form.authentication-form').submit(function(event) {
            event.preventDefault();
            const t = $(this);

            if( checkFormValidity(t) ) {
                submitForm(t);
            }
        });

        $('.authentication-form input').mousedown(function() {
            clickedElement = $(this);
        });

        function submitForm(form) {
            const submitButton = form.find('input[type="submit"]');
            submitButton.attr('disabled', 'disabled');

            $.post(
                form.attr('action').match(/login/)? 'https://www.filmon.com/ajax/login' : 'https://www.filmon.com/ajax/register',
                form.serializeArray(), "json"
            ).done(function(data) {
                if ( typeof data === "string" ) data = $.parseJSON(data);
                if( data.uid > 0  ) {
                    return data.return_url.length ? window.location = decodeURIComponent(data.return_url) : window.location.reload();
                } else {
                    showError.call(form.find('input[name="email"]'), data.reason );
                }
            }).fail( function(xhr,textStatus, error) {
                console.log([textStatus, error]);
                alert(FilmOn._("The authorization server encountered an unexpected condition and could not process your request. Sorry about that."));
                window.location.pathname =  "https://www.filmon.com/user/login" ;
            }).always( function() {
                submitButton.removeAttr('disabled');
            });
        }

    })
};
